/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: #ffdc2b;
  }
`

export default class SpecialIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" css={Color}>
          <path
            d="M214.01,319.54a23.949,23.949,0,1,0,7.04,16.96,23.117,23.117,0,0,0-7.04-16.96m-11.04,5.92a2.076,2.076,0,0,1,1.52.64,1.949,1.949,0,0,1,.56,1.44,1.933,1.933,0,0,1-2.08,2.08h-7.2a2.3,2.3,0,0,0-1.68.72,2.14,2.14,0,0,0-.72,1.68,2.3,2.3,0,0,0,.72,1.68,2.45,2.45,0,0,0,1.68.64h4.08a6,6,0,0,1,4.64,1.92,6.375,6.375,0,0,1,0,9.12,6.321,6.321,0,0,1-4.64,1.92h-7.36a2.232,2.232,0,0,1-1.52-.56,2.076,2.076,0,0,1-.64-1.52,1.826,1.826,0,0,1,.64-1.44,2.077,2.077,0,0,1,1.52-.64h7.36a2.2,2.2,0,0,0,2.32-2.32,2.171,2.171,0,0,0-.64-1.6,2.3,2.3,0,0,0-1.68-.72h-4.16a6.555,6.555,0,0,1-6.56-6.56,6.23,6.23,0,0,1,1.92-4.56,6.322,6.322,0,0,1,4.64-1.92Z"
            transform="translate(-173.05 -312.5)"
            fill="#ffdc2b"
          />
        </svg>
      </Fragment>
    )
  }
}
